import DatatableController, { responsiveModal } from "./datatable_base"

export default class extends DatatableController {
  datatableOptions() {
    return {
      aaSorting: [],
      dom: '<"row"<"col-md-6 "><"col-md-6"f>>rt<"row"<"col-md-12"p>>',
      displayLength: 40,
      lengthMenu: [25, 50, 75, 100],
      columns: [
        { width: "100%" } // Force the column to take full width
      ],
      autoWidth: false,
      responsive: responsiveModal()
    }
  }
}
